module.exports = __webpack_public_path__ + "img/verifikasi-web-icon-1.ea3d277c.svg";